import { render, staticRenderFns } from "./SelectSettings.vue?vue&type=template&id=3d4a514c&"
import script from "./SelectSettings.vue?vue&type=script&lang=js&"
export * from "./SelectSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports